<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="true"
                                id="dialog"
                                size="xl"
                                title="Machtigingen voor fiscaal nummer {{mumaList.at(0)?.taxPayerFiscalNumber}}">
  <snelstart-ui-dialog-header-content>
    Hieronder de status van de meest actuele machtigingen. Voer de meest voor de hand liggende acties
    uit, zoals een machtiging opvoeren of activeren. Meer informatie vind je bij de klant in de module 'Machtigingen'.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    @if (this.showTable) {
      <snelstart-ui-table [config]="tableConfig">
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Machtiging" name="type"
                                columnType="string"
                                i18n-displayName
                                markText
                                width="400px">
          <snelstart-ui-table-col-data>
            <ng-template let-record="record">
              <ng-container *ngIf="record.type.startsWith('SBA')">
                <a *ngIf="record.type === 'SBA_VpB_2024'">SBA vennootschapsbelasting 2024</a>
                <a *ngIf="record.type === 'SBA_VpB_2025'">SBA vennootschapsbelasting 2025</a>
                <a *ngIf="record.type === 'SBA_VpB_2026'">SBA vennootschapsbelasting 2026</a>
                <a *ngIf="record.type === 'SBA_IH_2024'">SBA inkomstenbelasting 2024</a>
                <a *ngIf="record.type === 'SBA_IH_2025'">SBA inkomstenbelasting 2025</a>
                <a *ngIf="record.type === 'SBA_IH_2026'">SBA inkomstenbelasting 2026</a>
                <a *ngIf="record.type === 'SBA_OB_2024'">SBA omzetbelasting 2024</a>
                <a *ngIf="record.type === 'SBA_OB_2025'">SBA omzetbelasting 2025</a>
                <a *ngIf="record.type === 'SBA_OB_2026'">SBA omzetbelasting 2026</a>
                <a *ngIf="record.type === 'SBA_TSG_2024'">SBA toeslagen 2024</a>
                <a *ngIf="record.type === 'SBA_TSG_2025'">SBA toeslagen 2025</a>
                <a *ngIf="record.type === 'SBA_TSG_2026'">SBA toeslagen 2026</a>
              </ng-container>
              <ng-container *ngIf="record.type.startsWith('VIA')">
                <a *ngIf="record.type === 'VIA_2024'">Vooraf ingevulde aangifte 2024</a>
                <a *ngIf="record.type === 'VIA_2025'">Vooraf ingevulde aangifte 2025</a>
              </ng-container>
              <ng-container *ngIf="record.type.startsWith('DoMa')">
                <a *ngIf="record.type === 'DoMa_IH'">Doorlopende machtiging inkomstenbelasting</a>
                <a *ngIf="record.type === 'DoMa_OB'">Doorlopende machtiging omzetbelasting</a>
                <a *ngIf="record.type === 'DoMa_VpB'">Doorlopende machtiging vennootschapsbelasting</a>
                <a *ngIf="record.type === 'DoMa_TSG'">Doorlopende machtiging toeslagen</a>
              </ng-container>
            </ng-template>
          </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Status" name="machtigingStatus" width="175px">
          <snelstart-ui-table-col-data>
            <ng-template let-record="record">
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.ONTVANGEN">Ontvangen</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && !this.checkIsOptInMachtiging(record.mumaRequest.dienst)">In behandeling</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && this.checkIsOptInMachtiging(record.mumaRequest.dienst)">Activeren</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.AFGEKEURD">Afgekeurd</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.ACTIEF">Actief</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.NIET_ACTIEF">Niet actief</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.CONTROLEREN">In controle</a>
              <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.UNKNOWN">Onbekend</a>
            </ng-template>
          </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Actie" name="mumaRequest" width="150px">
          <snelstart-ui-table-col-data>
            <ng-template let-record="record">
              @if (checkActie(record) === 'opvoeren') {
                <ng-container>
                  <a (click)="this.postEntity(record, MumaRequestMutatieType.Opvoeren)" type="link">
                    <snelstart-ui-badge [label]="'Opvoeren'" [small]="false" icon="arrow-right"
                                        [type]="'active'"></snelstart-ui-badge>
                  </a>
                </ng-container>
              }
              @else if (checkActie(record) === 'intrekken') {
                <a (click)="this.postEntity(record, MumaRequestMutatieType.Intrekken)" type="link">
                  <snelstart-ui-badge [label]="'Intrekken'" icon="arrow-right" [small]="false"
                                      [type]="'warning'"></snelstart-ui-badge>
                </a>
              }
              @else if (checkActie(record) === 'activeren') {
                @if(this.formGroup.get('activatieToken')?.getRawValue() !== null
                && this.formGroup.get('id')?.getRawValue() === record.id) {
                  <a (click)="this.postEntity(record, MumaRequestMutatieType.Activeren)" type="link">
                    <snelstart-ui-badge [label]="'Activeren'" icon="arrow-right" [small]="false"
                                        [type]="'success'"></snelstart-ui-badge>
                  </a>
                } @else {
                  <a (click)="this.showActivatieCode(record)" type="link">
                    <snelstart-ui-badge [label]="'Code invullen'" [small]="false"
                                        [type]="'default'"></snelstart-ui-badge>
                  </a>
                }
              }
              @else if (checkActie(record) === 'via ophalen') {
                <a (click)="this.postEntity(record, MumaRequestMutatieType.Activeren)" type="link">
                  <snelstart-ui-badge [label]="'Via ophalen'" icon="arrow-right" [small]="false"
                                      [type]="'active'"></snelstart-ui-badge>
                </a>
              }
              @else if (checkActie(record) === 'controleren' || checkActie(record) === 'in behandeling') {
                <snelstart-ui-badge [label]="'Geen actie nodig'" [small]="false"
                                    [type]="'default'"></snelstart-ui-badge>
              }
            </ng-template>
          </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Activatiecode" name="submissionDate" width="150px">
          <snelstart-ui-table-col-data>
            <ng-template let-record="record">
              @if(this.formGroup.get('id')?.getRawValue() === record.id) {
                <form [formGroup]="formGroup">
                  <input
                    type="text"
                    class="custom-input-100"
                    id="Activeringscode"
                    formControlName="activatieToken"
                  />
                </form>
              }
            </ng-template>
          </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
      </snelstart-ui-table>
    }
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false); this.showTable = false" btn-x icon="check" id="save"
                         type="primary">Afsluiten
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

